import { OpenCase } from '#models';

const openCases: OpenCase[] = [
  {
    id: 1,
    caseType: 'Pull Request',
    wellName: 'Adamcik 001',
    api14: '42481342110001',
    fot: 'UNKNOWN',
    status: 'Troubleshooting',
    stepLabel: 'IOC Request Entry',
    createDate: '4/22/26 4:29 AM',
  },
  {
    id: 2,
    caseType: 'Pull Request',
    wellName: 'Adamcik 001',
    api14: '42481342110001',
    fot: 'UNKNOWN',
    status: 'Troubleshooting',
    stepLabel: 'IOC Request Entry',
    createDate: '4/22/26 4:09 AM',
  },
  {
    id: 3,
    caseType: 'Plug & Abandonment',
    wellName: 'HAYDEN 08-05 51TB',
    api14: '42109335600001',
    fot: 'HAYHURST TX',
    status: 'WLM Review',
    stepLabel: 'Land Review',
    createDate: '4/20/26 11:54 AM',
  },
  {
    id: 4,
    caseType: 'Pull Request',
    wellName: 'ABWJR-A-14',
    api14: '42165362760001',
    fot: 'WHARTON',
    status: 'WLM Review',
    stepLabel: 'WLM Review',
    createDate: '4/20/26 11:08 AM',
  },
  {
    id: 5,
    caseType: 'POP',
    wellName: '',
    api14: '42461347599987',
    fot: 'UNKNOWN',
    status: 'PE Review',
    stepLabel: 'Complete Template',
    createDate: '4/17/26 1:36 AM',
  },
  {
    id: 6,
    caseType: 'Plug & Abandonment',
    wellName: 'COX 35 FEDERAL 2H',
    api14: '30025415210001',
    fot: 'HOBBS BASE',
    status: 'PE Workbook',
    stepLabel: 'Create Workbook',
    createDate: '4/16/26 2:37 PM',
  },
  {
    id: 7,
    caseType: 'Pull Request',
    wellName: 'COX 35 FEDERAL 2H',
    api14: '30025415210001',
    fot: 'HOBBS BASE',
    status: 'Troubleshooting',
    stepLabel: 'ALS Review',
    createDate: '4/16/26 2:35 PM',
  },
  {
    id: 8,
    caseType: 'Pull Request',
    wellName: 'Hayden Demo',
    api14: '12345678605555',
    fot: 'PECOS WEST',
    status: 'Job Execution',
    stepLabel: 'Daily Process',
    createDate: '4/16/26 10:53 AM',
  },
  {
    id: 9,
    caseType: 'POP',
    wellName: '',
    api14: '',
    fot: '',
    status: 'PE Review',
    stepLabel: 'Complete Template',
    createDate: '4/16/26 10:36 AM',
  },
  {
    id: 10,
    caseType: 'Pull Request',
    wellName: 'BRADFORD TRUST A UNIT 3 #...',
    api14: '42329396000000',
    fot: 'ANDREWS FMT',
    status: 'Job Execution',
    stepLabel: 'Daily Process',
    createDate: '4/16/26 7:11 AM',
  },
  {
    id: 11,
    caseType: 'Rigless',
    wellName: 'ADDISON #2',
    api14: '42461347510001',
    fot: 'QAFOT',
    status: 'Job Execution',
    stepLabel: 'WBS Daily Process',
    createDate: '4/16/26 4:03 AM',
  },
  {
    id: 12,
    caseType: 'POP',
    wellName: 'Hayden Demo 35HC',
    api14: '12345678901234',
    fot: 'PECOS WEST',
    status: 'Planner Review',
    stepLabel: 'Determine Execution Team',
    createDate: '4/15/26 3:47 PM',
  },
  {
    id: 13,
    caseType: 'Pull Request',
    wellName: 'HAYDEN 08-05 12WA',
    api14: '42109331220001',
    fot: 'HAYHURST TX',
    status: 'Troubleshooting',
    stepLabel: 'IOC Request Entry',
    createDate: '4/15/26 9:44 AM',
  },
  {
    id: 14,
    caseType: 'Pull Request',
    wellName: '',
    api14: '',
    fot: '',
    status: 'Pre Schedule',
    stepLabel: 'Pre Scheduling',
    createDate: '4/15/26 4:27 AM',
  },
  {
    id: 15,
    caseType: 'Pull Request',
    wellName: 'HAYDEN 08-05 12WA',
    api14: '42109331220001',
    fot: 'HAYHURST TX',
    status: 'Troubleshooting',
    stepLabel: 'Review Email',
    createDate: '4/14/26 3:46 PM',
  },
];

export default openCases;
